/**
 * [一般開発者利用可]
 * 環境種別
 */
export enum EnvironmentType {
  /** AWS本番環境 */
  PROD = 'production',

  /** AWSステージング環境 */
  STAGING = 'staging',

  /** AWS開発環境 */
  DEV = 'develop',

  /** IBM内AWSテスト環境 */
  TEST = 'test',

  /** ローカル開発環境 */
  LOCAL = 'local'

}
